import { z } from 'zod';

export const cardNumberSchema = (requiredMessage: string) =>
  z
    .string()
    .nonempty({ message: requiredMessage })
    .regex(/^[0-9]+$/, {
      message: requiredMessage,
    })
    .length(16, {
      message: requiredMessage,
    });
